module.exports = __webpack_public_path__ + "static/media/apple.a10b2baf.png";